import React from "react";
import { IProject } from "../../repositories/model/IProject";
import { IExamInfo } from "../../repositories/model/transfer/IExamInfo";
import { IPageSOBP, NeoStroke } from "../../neolab-libs/nl-lib3-common";
import { useStores } from "../../hooks/useStores";
import { QuestionNameToPageInfo } from "@/common/objects/QuestionAnswerToPageMapping/PdfToQAMapper";
import StrokeRecognizer from "@views/assignments/manage/OfflineSubmissions/CompareNeoPenData/StrokeRecognizer";

export const codeToRecognizedTextPromise = {};

export type IOcrResult =
	{
		recognizedText: string,
		ocrStatus: "none" | "requested" | "done" | "error"
	};

function useStrokeRecognition() {
	const { neoPenStore, navigateStore } = useStores();
	
	const [codeToOcrResultWithMS, setCodeToRecognizedText] = React.useState<{ [questionCode: string]: IOcrResult }>({});

	const [numRequestedWithMS, setNumRequested] = React.useState(0);
	const [numDoneWithMS, setNumDone] = React.useState(0);

	const [wholeStrokes, setWholeStrokes] = React.useState<NeoStroke[]>([]);
	const [nCodeRange, setNCodeRange] = React.useState<{ start: IPageSOBP, end: IPageSOBP }>(null);
	const [examInfoArray, setExamInfoArray] = React.useState<IExamInfo[]>([]);

	const putOfflineStrokesToRecognizeWithMS = (strokes: NeoStroke[], ncodeRange: { start: IPageSOBP, end: IPageSOBP }, examInfoArray: IExamInfo[]) => {
		setWholeStrokes(strokes);
		setNCodeRange(ncodeRange);
		setExamInfoArray(examInfoArray);
	}

	React.useEffect(() => {
		// Guard: require all inputs
		if (!wholeStrokes || wholeStrokes.length === 0) return;
		if (!nCodeRange) return;
		if (!examInfoArray || examInfoArray.length === 0) return;

		(async () => {
			try {
				const recognizer = new StrokeRecognizer(neoPenStore);
				recognizer.examList = examInfoArray;
				recognizer.wholeStrokes = wholeStrokes;
				recognizer.languageCode = navigateStore.locale;
				recognizer.ncodeRange = nCodeRange;

				const recognizedMap = await recognizer.recognize(); // Record<code, string>

				const next: { [key: string]: IOcrResult } = {};
				Object.keys(recognizedMap).forEach((code) => {
					next[code] = { recognizedText: recognizedMap[code] ?? "", ocrStatus: "done" };
				});
				setCodeToRecognizedText(next);
				setNumRequested(Object.keys(next).length);
				setNumDone(Object.keys(next).length);
			} catch (e) {
				console.error(e);
			}
		})();
	}, [wholeStrokes, nCodeRange, examInfoArray, neoPenStore]);

	return { codeToOcrResultWithMS, numRequestedWithMS, numDoneWithMS, putOfflineStrokesToRecognizeWithMS };
}

export default useStrokeRecognition;